export default "__VITE_ASSET__e5862a76__"